export default [{"url":"https://hayzedd-test1-0.api.invexerp.io","name":"Branch 1","port":"5026","isStore":true,"isHQ":true}]